// components/SeveritySelector.tsx
type PostReportProps = {
  selectedSeverity: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

const PostReport: React.FC<PostReportProps> = ({
  selectedSeverity,
  onChange,
}) => {
  return (
    <div className="w-full mb-4 space-y-1">
      <p>Select Issue Severity</p>
      <div className="flex justify-between items-center">
        {["Low", "Medium", "High", "Critical"].map(severity => (
          <div className="flex space-x-2 items-center" key={severity}>
            <input
              type="radio"
              id={severity.toLowerCase()}
              name="severity"
              value={severity}
              checked={selectedSeverity === severity}
              onChange={onChange}
              className="h-4 w-4 text-black border-gray-300 focus:ring-black accent-black"
            />
            <label
              htmlFor={severity.toLowerCase()}
              className="text-sm font-poppins"
            >
              {severity}
            </label>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PostReport;
